import { render, staticRenderFns } from "./RoleBox.vue?vue&type=template&id=c09ca34c&scoped=true"
import script from "./RoleBox.vue?vue&type=script&lang=js"
export * from "./RoleBox.vue?vue&type=script&lang=js"
import style0 from "./RoleBox.vue?vue&type=style&index=0&id=c09ca34c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c09ca34c",
  null
  
)

export default component.exports